<!-- Main Content -->
<div data-testid="o2o-internal-page" class="p-4 flex-table-page">
  <p-toast data-testid="o2o-internal-toast"></p-toast>

  <ng-template #o2oOrderDialogDetail>
    @if (dialogDetailOrderId(); as orderId) {
      <div class="o2o-dialog-order-detail">
        <app-o2o-order-view
          [embedMode]="true"
          [enableEditButton]="false"
          [inputOrderId]="orderId"
          [hideToast]="true"
        />
      </div>
    }
  </ng-template>

  <p-dialog
    data-testid="o2o-internal-cancel-dialog"
    [visible]="cancelDialogVisible()"
    (visibleChange)="onCancelDialogVisibleChange($event)"
    [modal]="true"
    [header]="cancelDialogTitle()"
    [draggable]="false"
    [resizable]="false"
    [closable]="!cancelSubmitting()"
    styleClass="o2o-action-dialog"
    [style]="{ width: 'min(92vw, 1280px)' }"
    [contentStyle]="{ overflow: 'auto', maxHeight: '75vh' }"
    appendTo="body"
  >
    @if (cancelPendingOrderIds().length > 1) {
      <p class="text-sm text-gray-600 mb-3">{{ cancelDialogHint() }}</p>
    } @else {
      <ng-container *ngTemplateOutlet="o2oOrderDialogDetail"></ng-container>
    }
    <hr class="o2o-dialog-detail__divider" />
    <div class="o2o-dialog-reason-field">
      <label class="form-label text-sm" for="o2o-cancel-reason-code">
        {{ 'o2o.internal.cancel_order.reason_label' | translate }}
        <span class="text-red-500">*</span>
      </label>
      <p-select
        data-testid="o2o-internal-cancel-reason-select"
        inputId="o2o-cancel-reason-code"
        [options]="cancelReasons()"
        optionLabel="reasonDescribe"
        optionValue="reasonCode"
        [ngModel]="cancelReasonCode()"
        (ngModelChange)="onCancelReasonCodeChange($event)"
        [disabled]="cancelSubmitting()"
        [placeholder]="'o2o.internal.cancel_order.reason_placeholder' | translate"
        class="w-full"
        [appendTo]="'body'"
        [showClear]="true"
      ></p-select>
      @if (cancelReasonCodeShowError() && !cancelReasonCode()) {
        <small class="o2o-dialog-reason-error">
          {{ 'o2o.internal.cancel_order.reason_code_required' | translate }}
        </small>
      }
    </div>
    <div class="o2o-dialog-reason-field">
      <label class="form-label text-sm" for="o2o-cancel-reason-note">
        {{ 'o2o.internal.cancel_order.note_label' | translate }}
        @if (cancelNoteRequired()) {
          <span class="text-red-500">*</span>
        }
      </label>
      <input
        data-testid="o2o-internal-cancel-reason-input"
        pInputText
        type="text"
        id="o2o-cancel-reason-note"
        class="w-full"
        [ngModel]="cancelReasonText()"
        (ngModelChange)="onCancelReasonInput($event)"
        [disabled]="cancelSubmitting()"
        [placeholder]="'o2o.internal.cancel_order.note_placeholder' | translate"
        [class.o2o-dialog-reason-input--invalid]="
          cancelReasonShowError() && !cancelReasonText().trim()
        "
      />
      @if (cancelReasonShowError() && !cancelReasonText().trim()) {
        <small class="o2o-dialog-reason-error">
          {{ 'o2o.internal.cancel_order.note_required' | translate }}
        </small>
      }
    </div>
    <ng-template pTemplate="footer">
      <div class="flex justify-end gap-2 pt-2">
        <app-button
          [testId]="'o2o-internal-cancel-dialog-cancel-btn'"
          type="secondary"
          [outlined]="true"
          [label]="'common.actions.cancel' | translate"
          [disabled]="cancelSubmitting()"
          (emitOnClick)="onCancelDialogVisibleChange(false)"
        ></app-button>
        <app-button
          [testId]="'o2o-internal-cancel-dialog-confirm-btn'"
          type="danger"
          [label]="'common.actions.confirm' | translate"
          [disabled]="cancelSubmitting()"
          (emitOnClick)="onConfirmCancelFromDialog()"
        ></app-button>
      </div>
    </ng-template>
  </p-dialog>

  <p-dialog
    data-testid="o2o-internal-audit-dialog"
    [visible]="auditDialogVisible()"
    (visibleChange)="onAuditDialogVisibleChange($event)"
    [modal]="true"
    [header]="'o2o.internal.audit_order.dialog_title' | translate"
    [draggable]="false"
    [resizable]="false"
    [closable]="!auditSubmitting()"
    styleClass="o2o-action-dialog"
    [style]="{ width: 'min(92vw, 1280px)' }"
    [contentStyle]="{ overflow: 'auto', maxHeight: '75vh' }"
    appendTo="body"
  >
    <ng-container *ngTemplateOutlet="o2oOrderDialogDetail"></ng-container>
    <hr class="o2o-dialog-detail__divider" />
    <div class="o2o-dialog-reason-field">
      <label class="form-label text-sm" for="o2o-audit-reject-reason">
        {{ 'o2o.internal.audit_order.reject_reason_label' | translate }}
        <span class="text-red-500">*</span>
      </label>
      <input
        data-testid="o2o-internal-audit-reject-reason-input"
        pInputText
        type="text"
        id="o2o-audit-reject-reason"
        class="w-full"
        [ngModel]="auditRejectReason()"
        (ngModelChange)="onAuditRejectReasonInput($event)"
        [disabled]="auditSubmitting()"
        [placeholder]="
          'o2o.internal.audit_order.reject_reason_placeholder' | translate
        "
        [class.o2o-dialog-reason-input--invalid]="
          auditRejectReasonShowError() && !auditRejectReason().trim()
        "
      />
      @if (auditRejectReasonShowError() && !auditRejectReason().trim()) {
        <small class="o2o-dialog-reason-error">
          {{ 'o2o.internal.audit_order.reason_required' | translate }}
        </small>
      }
      <p class="o2o-dialog-reason-hint">
        {{ 'o2o.internal.audit_order.reject_hint' | translate }}
      </p>
    </div>
    <ng-template pTemplate="footer">
      <div class="flex justify-end gap-2 pt-2">
        <app-button
          [testId]="'o2o-internal-audit-dialog-cancel-btn'"
          type="secondary"
          [outlined]="true"
          [label]="'common.actions.cancel' | translate"
          [disabled]="auditSubmitting()"
          (emitOnClick)="onAuditDialogVisibleChange(false)"
        ></app-button>
        <app-button
          [testId]="'o2o-internal-audit-dialog-reject-btn'"
          type="danger"
          [outlined]="true"
          [label]="'o2o.internal.audit_order.reject' | translate"
          [disabled]="auditSubmitting()"
          (emitOnClick)="onRejectAudit()"
        ></app-button>
        <app-button
          [testId]="'o2o-internal-audit-dialog-approve-btn'"
          type="success"
          [label]="'o2o.internal.audit_order.approve' | translate"
          [disabled]="auditSubmitting()"
          (emitOnClick)="onApproveAudit()"
        ></app-button>
      </div>
    </ng-template>
  </p-dialog>

  <p-dialog
    data-testid="o2o-internal-receive-dialog"
    [visible]="receiveDialogVisible()"
    (visibleChange)="onReceiveDialogVisibleChange($event)"
    [modal]="true"
    [header]="'o2o.internal.confirm_customer_receive.dialog_title' | translate"
    [draggable]="false"
    [resizable]="false"
    [closable]="!receiveSubmitting()"
    [style]="{ width: 'min(32rem, 95vw)' }"
    appendTo="body"
  >
    <label
      class="block text-sm font-medium text-gray-700 mb-1"
      for="o2o-receive-notes"
      >{{
        'o2o.internal.confirm_customer_receive.notes_label' | translate
      }}</label
    >
    <input
      data-testid="o2o-internal-receive-notes-input"
      pInputText
      type="text"
      id="o2o-receive-notes"
      class="w-full"
      [ngModel]="receiveNotes()"
      (ngModelChange)="receiveNotes.set($event)"
      [disabled]="receiveSubmitting()"
      [placeholder]="
        'o2o.internal.confirm_customer_receive.notes_placeholder' | translate
      "
    />
    <ng-template pTemplate="footer">
      <div class="flex justify-end gap-2 pt-2">
        <app-button
          [testId]="'o2o-internal-receive-dialog-cancel-btn'"
          type="secondary"
          [outlined]="true"
          [label]="'common.actions.cancel' | translate"
          [disabled]="receiveSubmitting()"
          (emitOnClick)="onReceiveDialogVisibleChange(false)"
        ></app-button>
        <app-button
          [testId]="'o2o-internal-receive-dialog-confirm-btn'"
          type="success"
          [label]="'common.actions.confirm' | translate"
          [disabled]="receiveSubmitting()"
          (emitOnClick)="onConfirmCustomerReceiveFromDialog()"
        ></app-button>
      </div>
    </ng-template>
  </p-dialog>

  <p-dialog
    data-testid="o2o-internal-delivery-failed-dialog"
    [visible]="deliveryFailedDialogVisible()"
    (visibleChange)="onDeliveryFailedDialogVisibleChange($event)"
    [modal]="true"
    [header]="'o2o.internal.confirm_delivery_failed.dialog_title' | translate"
    [draggable]="false"
    [resizable]="false"
    [closable]="!deliveryFailedSubmitting()"
    [style]="{ width: 'min(32rem, 95vw)' }"
    appendTo="body"
  >
    <label
      class="block text-sm font-medium text-gray-700 mb-1"
      for="o2o-delivery-failed-notes"
      >{{
        'o2o.internal.confirm_delivery_failed.notes_label' | translate
      }}</label
    >
    <input
      data-testid="o2o-internal-delivery-failed-notes-input"
      pInputText
      type="text"
      id="o2o-delivery-failed-notes"
      class="w-full"
      [ngModel]="deliveryFailedNotes()"
      (ngModelChange)="deliveryFailedNotes.set($event)"
      [disabled]="deliveryFailedSubmitting()"
      [placeholder]="
        'o2o.internal.confirm_delivery_failed.notes_placeholder' | translate
      "
    />
    <ng-template pTemplate="footer">
      <div class="flex justify-end gap-2 pt-2">
        <app-button
          [testId]="'o2o-internal-delivery-failed-dialog-cancel-btn'"
          type="secondary"
          [outlined]="true"
          [label]="'common.actions.cancel' | translate"
          [disabled]="deliveryFailedSubmitting()"
          (emitOnClick)="onDeliveryFailedDialogVisibleChange(false)"
        ></app-button>
        <app-button
          [testId]="'o2o-internal-delivery-failed-dialog-confirm-btn'"
          type="success"
          [label]="'common.actions.confirm' | translate"
          [disabled]="deliveryFailedSubmitting()"
          (emitOnClick)="onConfirmDeliveryFailedFromDialog()"
        ></app-button>
      </div>
    </ng-template>
  </p-dialog>

  <h2 class="text-2xl font-semibold text-gray-800 mb-3 flex-table-header">
    {{ titleKey | translate }}
  </h2>
  <!-- Search Form -->
  <app-search-form
    data-testid="o2o-internal-search-form"
    [searchFormat]="searchConfig"
    (formSearch)="onSearch($event)"
    (formReset)="onReset()"
  >
    <div slot="actions" class="flex gap-2">
      <app-button
        [testId]="'o2o-internal-column-config-btn'"
        type="success"
        [outlined]="true"
        icon="view_column"
        (emitOnClick)="onColumnConfigClick($event)"
      ></app-button>
      <app-status-filter
        [primaryButton]="primaryButton()"
        (primaryButtonClick)="createOrder()"
      ></app-status-filter>
    </div>
  </app-search-form>

  <!-- Status Filter with Action Buttons -->
  <!-- <div class="mb-2">
      <app-status-filter
        [statusOptions]="statusOptions"
        (statusChange)="onStatusChange($event)"
      ></app-status-filter>
    </div> -->

  <!-- Data Table -->
  <div class="flex-table-section">
    <advanced-data-table
      data-testid="o2o-internal-table"
      #advancedTable
      [dataSource]="orders()"
      [defaultColumns]="defaultColumns()"
      [flexibleColumns]="flexibleColumns()"
      [loading]="loading()"
      [rows]="searchParams().size"
      [first]="(searchParams().page - 1) * searchParams().size"
      [totalRecords]="totalRecords()"
      scrollHeight="flex"
      [showInternalColumnConfigButton]="false"
      [hasCheckColumn]="false"
      class="w-full"
      (pageChange)="onPageChange($event)"
    >
    <ng-template
      #customTemplate
      let-value
      let-rowData="rowData"
      let-column="column"
    >
      @if (column && column.template === "operationTimeTemplate") {
        <span class="text-xs text-gray-600 flex items-center justify-center">
          {{ formatDateTime(value) }}
        </span>
      } @else if (column && column.template === "currencyTemplate") {
        <span class="text-xs text-gray-600 flex items-center justify-end">
          {{ formatCurrency(value) }}
        </span>
      } @else if (column && column.template === "statusTemplate") {
        <span class="flex items-center justify-center">
          <p-tag
            data-testid="o2o-internal-status-tag"
            [value]="getStatusDisplayText(column.prop, value) | translate"
            [severity]="getStatusSeverity(column.prop, value)"
            styleClass="status-tag"
            [ngStyle]="getStatusStyle(column.prop, value)"
            [pTooltip]="getStatusTooltip(column.prop, value) | translate"
            tooltipPosition="top"
            tooltipStyleClass="custom-tooltip"
            [showDelay]="300"
            [hideDelay]="0"
          />
        </span>
      } @else if (column && column.template === "typeTemplate") {
        <span class="text-xs text-gray-600 flex items-center justify-center">
          {{ getStatusDisplayText(column.prop, value) | translate }}
        </span>
      } @else if (column && column.prop === "giftStatus") {
        <p-tag
          data-testid="o2o-internal-gift-status-tag"
          [value]="
            value
              ? ('common.table.status.yes' | translate)
              : ('common.table.status.no' | translate)
          "
          [severity]="value ? 'success' : 'danger'"
          styleClass="status-tag"
          [pTooltip]="
            value
              ? ('common.table.status.yes' | translate)
              : ('common.table.status.no' | translate)
          "
          tooltipPosition="top"
          tooltipStyleClass="custom-tooltip"
          [showDelay]="300"
          [hideDelay]="0"
        />
      } @else if (column && column.template === "stockHoldCategoryTemplate") {
        <span class="text-xs text-gray-600">
          {{ getStockHoldCategoryLabel(rowData.stockHoldCategory) }}
        </span>
      } @else if (column && column.template === "stockHoldExpiryTemplate") {
        @if (
          hasStockHoldExpiryDisplay(
            rowData.stockHoldExpiryTime,
            rowData.failureReasonDescription
          )
        ) {
          <p-tag
            [value]="
              getStockHoldExpiryLabel(
                rowData.stockHoldExpiryTime,
                rowData.failureReasonDescription
              )
            "
            [severity]="
              getStockHoldExpirySeverity(
                rowData.stockHoldExpiryTime,
                rowData.failureReasonDescription
              )
            "
            styleClass="status-tag"
          />
        } @else {
          <span class="text-xs text-gray-500">
            {{ 'stock_hold_timeout.order.no_limit' | translate }}
          </span>
        }
      } @else if (column && column.template === "stockHoldTimeoutTemplate") {
        <span class="text-xs text-gray-600">
          {{ formatStockHoldTimeout(rowData.stockHoldTimeoutMinutes) }}
        </span>
      } @else if (column && column.template === "failureReasonTemplate") {
        @if (rowData.failureReasonDescription) {
          <p-tag
            [value]="getFailureReasonLabel(rowData.failureReasonDescription)"
            [pTooltip]="getFailureReasonLabel(rowData.failureReasonDescription)"
            tooltipPosition="top"
            [severity]="
              rowData.failureReasonDescription === 'STOCK_HOLD_TIMEOUT'
                ? 'danger'
                : 'secondary'
            "
            styleClass="status-tag"
          />
        } @else if (rowData.cancelReasonCode) {
          <p-tag
            [value]="getCancelReasonLabel(rowData.cancelReasonCode)"
            [pTooltip]="getCancelReasonLabel(rowData.cancelReasonCode)"
            tooltipPosition="top"
            severity="secondary"
            styleClass="status-tag"
          />
        }
      }
    </ng-template>
    <ng-template #actionsTemplate let-rowData>
      <div class="flex gap-2 justify-center flex-nowrap items-center">
        @if (canRead()) {
          <app-button
            [testId]="'o2o-internal-action-view-' + (rowData.id || rowData.orderId || rowData.orderNumber || rowData.code)"
            class="action-view"
            [label]="'common.actions.view' | translate"
            type="action"
            (emitOnClick)="onView(rowData)"
          ></app-button>
        }
        @if (
          enableFulfillmentActions &&
          !isFulfillmentNotStarted(rowData) &&
          canDelete() &&
          hasNextAction(rowData, nextAction.CANCEL_ORDER)
        ) {
          <app-button
            [testId]="'o2o-internal-action-cancel-order-' + (rowData.id || rowData.orderId || rowData.orderNumber || rowData.code)"
            class="action-cancel-order"
            [label]="'o2o.internal.cancel_order.button' | translate"
            type="action"
            [disabled]="cancelSubmitting()"
            (emitOnClick)="onCancelOrderRow(rowData)"
          ></app-button>
        }
        @if (
          enableFulfillmentActions &&
          !isFulfillmentNotStarted(rowData) &&
          canApprove() &&
          hasNextAction(rowData, nextAction.AUDIT_ORDER)
        ) {
          <app-button
            [testId]="'o2o-internal-action-audit-order-' + (rowData.id || rowData.orderId || rowData.orderNumber || rowData.code)"
            class="action-audit-order"
            [label]="'o2o.internal.audit_order.button' | translate"
            type="action"
            [disabled]="auditSubmitting()"
            (emitOnClick)="onAuditOrderRow(rowData)"
          ></app-button>
        }
        @if (
          enableFulfillmentActions &&
          !isFulfillmentNotStarted(rowData) &&
          canUpdate() &&
          hasNextAction(rowData, nextAction.CONFIRM_CUSTOMER_RECEIVE)
        ) {
          <app-button
            [testId]="'o2o-internal-action-confirm-receive-' + (rowData.id || rowData.orderId || rowData.orderNumber || rowData.code)"
            class="action-confirm-receive"
            [label]="
              'o2o.internal.confirm_customer_receive.button' | translate
            "
            type="action"
            [disabled]="receiveSubmitting()"
            (emitOnClick)="onConfirmCustomerReceiveRow(rowData)"
          ></app-button>
        }
        @if (
          enableFulfillmentActions &&
          !isFulfillmentNotStarted(rowData) &&
          canUpdate() &&
          hasNextAction(rowData, nextAction.CONFIRM_DELIVERY_FAILED)
        ) {
          <app-button
            [testId]="'o2o-internal-action-confirm-delivery-failed-' + (rowData.id || rowData.orderId || rowData.orderNumber || rowData.code)"
            class="action-confirm-delivery-failed"
            [label]="
              'o2o.internal.confirm_delivery_failed.button' | translate
            "
            type="action"
            [disabled]="deliveryFailedSubmitting()"
            (emitOnClick)="onConfirmDeliveryFailedRow(rowData)"
          ></app-button>
        }
        @if (
          enableFulfillmentActions &&
          !isFulfillmentNotStarted(rowData) &&
          canUpdate() &&
          hasNextAction(rowData, nextAction.RETRY_DELIVERY)
        ) {
          <app-button
            [testId]="'o2o-internal-action-retry-delivery-' + (rowData.id || rowData.orderId || rowData.orderNumber || rowData.code)"
            class="action-retry-delivery"
            [label]="'o2o.internal.retry_delivery.button' | translate"
            type="action"
            (emitOnClick)="onRetryDeliveryRow(rowData)"
          ></app-button>
        }
        @if (
          enableFulfillmentActions &&
          !isFulfillmentNotStarted(rowData) &&
          canUpdate() &&
          hasNextAction(rowData, nextAction.RETURN_STOCK)
        ) {
          <app-button
            [testId]="'o2o-internal-action-return-stock-' + (rowData.id || rowData.orderId || rowData.orderNumber || rowData.code)"
            class="action-return-stock"
            [label]="'o2o.internal.return_stock.button' | translate"
            type="action"
            (emitOnClick)="onReturnStockRow(rowData)"
          ></app-button>
        }
      </div>
    </ng-template>
    </advanced-data-table>
  </div>

  <!-- Order Item Dialog -->
  <app-order-item-dialog
    data-testid="o2o-internal-item-dialog"
    [visible]="showOrderItemDialog()"
    [orderId]="selectedOrderId()"
    [orderNumber]="selectedOrderNumber()"
    (visibleChange)="onOrderItemDialogVisibleChange($event)"
  ></app-order-item-dialog>
</div>
